import ApiService from '@/core/api/api.service';

import { functionsWithNotifications } from '@/core/notifications';
import vendorMessages from './vendor.messages';
import Vendor from './vendor.mapper';

const vendorApi = new ApiService();

const functions = {
  all,
  get,
};

export default {
  ...functionsWithNotifications(functions, vendorMessages),
};

async function all() {
  const response = await vendorApi.get('vendors');
  return response.data.data.map(vendor => new Vendor(vendor));
}

async function get(vendorUuid) {
  const response = await vendorApi.get(`vendors/${vendorUuid}`);
  return new Vendor(response.data.data);
}
